"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Color = require("color");
var common_1 = require("docs/common");
var components_1 = require("components");
var componentStyle = {
    base: {
        backgroundColor: '#3498db',
        ':active': {
            backgroundColor: Color('#3498db').lighten(.2).rgb().string(),
        },
    },
};
var description = 'You can style it as well with <code class="inline">style</code> ' +
    'property. To change icon color, use <code class="inline">iconColor</code> ' +
    'property.';
var code = "import React from 'react';\nimport { IconButton } from 'jsc-react-ui';\n\nconst style = {\n  backgroundColor: '#3498db',\n  ':active': {\n    backgroundColor: '#63b0e3',\n  },\n};\n\nconst Example = () => <IconButton style={style} iconName=\"plus\" iconColor=\"#f8f8f8\" />;";
exports.StylingExampleIconButton = function () { return (React.createElement(common_1.Example, { title: "Styling", description: description, code: code },
    React.createElement(components_1.IconButton, { style: componentStyle.base, iconName: "plus", iconColor: "#f8f8f8" }))); };
exports.StylingExampleIconButton.displayName = 'StylingExampleIconButton';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentIconButtonPage/StylingExampleIconButton.tsx
// module id = 680
// module chunks = 0